import { library } from '@fortawesome/fontawesome-svg-core'
import * as solid from './v5/solid'
import * as regular from './v5/regular'
import * as light from './v5/light'
import * as duotone from './v5/duotone'
import * as brands from './v5/brands'
import * as custom from './custom'
import * as avatarsUsers from './v5/avatars/users'
import { faGlobeAmericas, faSolarSystem, faPlanetRinged } from '@fortawesome/pro-regular-svg-icons'

library.add(solid, regular, light, duotone, brands, custom, avatarsUsers, faGlobeAmericas, faSolarSystem, faPlanetRinged)
